import React, {Component} from 'react';
import {Table} from 'react-data-components';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import * as CoursesActions from '../../store/actions/coursesActions';

const questionTemplate = {
    question: '',
    optionA: '',
    optionB: '',
    optionC: '',
    optionD: '',
    correctOption: '',
    concept: ''
}

const courses = [
    {
        course: 'MCAT',
        subject: 'Maths',
        title: 'Angelfish piranha alas hey much b',
        options: 'options',
        id: '000010'
    },
    {
        course: 'LSAT',
        subject: 'Physics',
        title: 'Justly away shaky re-laid including therefore m',
        options: 'options',
        id: '000020'
    },
    {
        course: 'GMAT',
        subject: 'Maths',
        title: 'Shrank less unlocked messy without bird hellish',
        options: 'options',
        id: '000030'
    },
    {
        course: 'GMAT',
        subject: 'Physics',
        title: 'Debating me breeding be answered an',
        options: 'options',
        id: '000040'
    },
    {
        course: 'MCAT',
        subject: 'Chemistry',
        title: 'His followed carriage proposal entrance',
        options: 'options',
        id: '000050'
    },
    {
        course: 'MCAT',
        subject: 'Chemistry',
        title: 'Literature admiration frequently indulgence',
        options: 'options',
        id: '000060'
    },
    {
        course: 'MCAT',
        subject: 'Physics',
        title: 'Mandrill insufferable ouc',
        options: 'options',
        id: '000070'
    },
    {
        course: 'GMAT',
        subject: 'Chemistry',
        title: 'More preparatory much derisively far impul',
        options: 'options',
        id: '000080'
    },
    {
        course: 'LSAT',
        subject: 'Chemistry',
        title: 'More preparatory much derisively fa',
        options: 'options',
        id: '000090'
    }
];

const questions = [
    {
        id: '0020201',
        title: 'Question',
        number: 1,
        description: '',
        removeQuestion: false,
        checkedOption: 'C',
        optionA: '',
        optionB: '',
        optionC: '',
        optionD: ''
    }
];

const testTemplate = {
    title: '',
    show_description: '',
    instructions: '',
    course: '',
    subject: '',
    sections: [
        {name: '', questions: [], subjectId: ''}
    ]
}

class ChapterTestModal extends Component {
    state = {
        columns: [],
        activeCourse: {},
        activeSection: 0,
        test: {
            title: '',
            show_description: '',

            instructions: '',
            course: '',
            courseId: '',
            subject: '',
            sections: [
                {name: '', subjectId: '', questions: []}
            ]
        },
        tests: [],
        currentTab: 0
    };

    getTests = () => {
        if(this.props.match.params.courseId){
            this.props.getCourseTests(this.props.match.params.courseId, this.props.user.id);
        }
    }

    componentDidMount(){
        this.getTests();
    }

    componentDidUpdate(props){
        if(props.match.params.courseId !== this.props.match.params.courseId || (!props.match.params.courseId && this.props.match.params.courseId)){
            this.getTests();
        }


        if(this.props.chapterTests){
        if(props.chapterTests !== this.props.chapterTests || this.state.tests.length !== this.props.chapterTests.length + 1){
            const tt = {
                id: 1,
                courseId: '',
                subjectId: '',
                name: '',
                sections: [{name: '', instructions: '', questions: []}],
                instructions: '',
                show_description: '',
                testLocation: 'content',
                testType: '',
                type: ''
    
            }
            this.setState({tests: this.props.chapterTests.concat(tt)});
        }
        }
    }
    
    renderTestName = (val, row) => {
        if(row.id === 1){
            return (
                <div>Create New</div>
            )
        }else{
            return (
                <div>{row.name}</div>
            )
        }
    }

    updateTestField = (id, field, val) => {
        let {tests} = this.state;
        tests = tests.map(t => {
            if(t.id === id){
                return {
                    ...t,
                    [field]: val
                }
            }else{
                return t
            }
        })

        this.setState({tests});
    }
    
    renderTestOptions = (val, row) => {
        return (
            <div>
                    <select className="form-control" value={row.testMode} onChange={e => {
                        this.updateTestField(row.id, 'testMode', e.target.value);
                    }} >
                    
                        <option value="">Choose</option>
                        <option value="practice">Practice (untimed)</option>
                        <option value="training">Training Wheels (Semi-Timed)</option>
                        <option value="timed">Timed</option>
                    </select>
                
                
            </div>
        )
    }
    
    renderScoringOptions = (val, row) => {
        return (
            <div>
                    <select className="form-control" value={row.scoring} onChange={e => {
                        this.updateTestField(row.id, 'scoring', e.target.value);
                    }} >
                    
                        <option value="">Choose</option>
                        <option value="score">80% Score</option>
                        <option value="correct10">10 Correct Questions</option>
                    </select>
                
                
            </div>
        )
    }

    renderFailOptions = (val, row) => {
        return (
            <div>
                    <select className="form-control" value={row.failBehavior} onChange={e => {
                        this.updateTestField(row.id, 'failBehavior', e.target.value);
                    }} >
                    
                        <option value="">Choose</option>
                        <option value="lecture">Retake Test</option>
                        <option value="Subject">Reset Subject</option>
                    </select>
                
                
            </div>
        )
    }

    //Renders
    renderOptions = (val, row) => {
        return (
            <div className="">
                <button 
                    data-dismiss="modal"
                   className="btn btn-default"
                   onClick={e => {

                       this.props.createChapterTestFromTemplate(row, this.props.subjectId, this.props.number);
                   }}
                >
                    Add Here
                </button>
                
            </div>
        )
    }


    renderQuestions = (sections) => {

        if(this.state.activeSection >= 0 && sections[this.state.activeSection]){
            return sections[this.state.activeSection].questions.map((item, index) => (
                <div
                    key={index}
                    className="panel customPanel"
                >
                    <div className="panel-heading border-bottom bg-light">
                        <div className="panel-control">
                            <a
                                href="#"
                                className="btn btn-danger"
                                onClick={(e) => {
                                    let {test} = this.state;
                                    test.sections[this.state.activeSection].questions.splice(index, 1);
                                    this.setState({test});
                                }}
                            >
                                <i className="zmdi zmdi-delete"/>
                            </a>
                        </div>
                        <h3 className="panel-title">
                            {item.title}
                            <span className="new_test_question_number">
                            {item.number}
                        </span>
                        </h3>
                    </div>
                    <div className="panel-body bg-light-2">
                        <div className="row">

                            <div className="col-sm-7">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <label>Correct Option</label>
                                        <select
                                            className="form-control"
                                            value={this.state.test.sections[this.state.activeSection].questions[index].correctOption}
                                            onChange={(e) => {
                                                let {test} = this.state;
                                                test.sections[this.state.activeSection].questions[index].correctOption = e.target.value;
                                                this.setState({test});
                                            }}>
                                            <option value="">Select correct answer</option>
                                            <option value={"A"}>A</option>
                                            <option value={"B"}>B</option>
                                            <option value={"C"}>C</option>
                                            <option value={"D"}>D</option>
                                            {this.state.test.answer_choices == 5 &&
                                            <option value={"E"}>E</option>
                                            }

                                        </select>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="sm-top10">
                                    <br/>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Concept"
                                        value={item.concept}
                                        onChange={(e) => {
                                            let {test} = this.state;
                                            test.sections[this.state.activeSection].questions[index].concept = e.target.value;
                                            this.setState({test});
                                        }}
                                    />
                                </div>
                                <br/>
                                <div className="sm-top10">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Question"
                                        value={item.question}
                                        onChange={(e) => {
                                            let {test} = this.state;
                                            test.sections[this.state.activeSection].questions[index].question = e.target.value;
                                            this.setState({test});
                                        }}
                                    />
                                </div>
                                <br/>
                                <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    placeholder="Option A"
                                    rows="2"
                                    value={item.optionA}
                                    onChange={(e) => {
                                        let {test} = this.state;
                                        test.sections[this.state.activeSection].questions[index].optionA = e.target.value;
                                        this.setState({test});
                                    }}
                                />
                                </div>
                                <br/>
                                <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    placeholder="Option B"
                                    rows="2"
                                    value={item.optionB}
                                    onChange={(e) => {
                                        let {test} = this.state;
                                        test.sections[this.state.activeSection].questions[index].optionB = e.target.value;
                                        this.setState({test});
                                    }}
                                />
                                </div>
                                <br/>
                                <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    placeholder="Option C"
                                    rows="2"
                                    value={item.optionC}
                                    onChange={(e) => {
                                        let {test} = this.state;
                                        test.sections[this.state.activeSection].questions[index].optionC = e.target.value;
                                        this.setState({test});
                                    }}
                                />
                                </div>
                                <br/>
                                <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    placeholder="Option D"
                                    rows="2"
                                    value={item.optionD}
                                    onChange={(e) => {
                                        let {test} = this.state;
                                        test.sections[this.state.activeSection].questions[index].optionD = e.target.value;
                                        this.setState({test});
                                    }}
                                />
                                </div>

                                {this.state.test.answer_choices == 5 &&
                                <div className="sm-top10">
                                <textarea
                                    className="form-control"
                                    placeholder="Option E"
                                    rows="2"
                                    value={item.optionE}
                                    onChange={(e) => {
                                        let {test} = this.state;
                                        test.sections[this.state.activeSection].questions[index].optionE = e.target.value;
                                        this.setState({test});
                                    }}
                                />
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            ))
        }
    }

    saveTest = () => {
        let nt = {
            ...this.state.test,
            status: false
        }
        this.props.saveTest(nt, this.props.user.id);
        this.setState({currentTab: 0, test: testTemplate, activeSection: 0});
    }

    //Lifecycle
    componentDidMount(props) {
        this.setState({
            columns: [
                {title: 'Course', prop: 'course'},
                {title: 'Title', prop: 'id', render: this.renderTestName},
                {title: 'Type', prop: 'id', render: this.renderTestOptions},
                {title: 'Scoring', prop: 'id', render: this.renderScoringOptions},
                {title: 'If Failed', prop: 'id', render: this.renderFailOptions},
                {title: 'Actions', prop: 'id', render: this.renderOptions}
            ]
        })
    }


    componentWillUpdate(props){
        if(this.props.course !== props.course){
            let {test} = this.state;
            test.courseId = props.course.id;
            test.course = props.course.name;
            test.sections = [];

            props.course.CourseSubject.map(sub => {
                test.sections.push({name: '', questions: [], subjectId: sub.id})
            })

            this.setState({test, activeCourse: props.course});
        }
    }




    render() {
        
        return (
            <div className="modal fade" id={this.props.modalId} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-body no-padding">
                            <div className="nav-tabs-custom ">
                                <ul className="nav nav-tabs">
                                    <li className={this.state.currentTab == 0 ? "active" : ""}>
                                        <a href="#tab_21" data-toggle="tab" onClick={(e) => {
                                            e.preventDefault();
                                            this.setState({currentTab: 0});
                                        }}>
                                            Saved Test Templates
                                        </a>
                                    </li>
                                    {/*
                                    <li className={this.state.currentTab == 1 ? "active" : ""}>
                                        <a href="/tests">
                                            Add Test Template
                                        </a>
                                    </li>
                                    */}
                                </ul>
                                <div className="tab-content">
                                    <div className={this.state.currentTab == 0 ? "tab-pane active no-padding" : "tab-pane no-padding"} id="tab_21">
                                       
                                            <Table
                                                className="table table-bordered table-striped"
                                                keys="id"
                                                dataArray={this.state.tests ? this.state.tests : []}
                                                columns={this.state.columns }
                                            />
                                            
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            {this.state.currentTab === 1 &&
                                <div>
                                    <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                                    <button type="button" className="btn btn-primary" onClick={this.saveTest}>Save changes</button>
                                </div>

                            }

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    ...state.courses,
    ...state.auth
});

const mapDispatchToProps = dispatch => ({
    getCourseTests: (courseId, token) => {
        dispatch(CoursesActions.getAllTests(courseId, token));
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ChapterTestModal));


// WEBPACK FOOTER //
// ./src/components/AdminPanel/ChapterTestModal.js